import { render, staticRenderFns } from "./admin-new.vue?vue&type=template&id=06d39387&scoped=true&"
import script from "./admin-new.vue?vue&type=script&lang=js&"
export * from "./admin-new.vue?vue&type=script&lang=js&"
import style0 from "./admin-new.vue?vue&type=style&index=0&id=06d39387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d39387",
  null
  
)

export default component.exports